/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './message-editor.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/clmtlk/new-message/message-form/message-editor/message-editor.component';
import * as i3 from '@angular/forms';
import * as i4 from '../../../../../../app/clmtlk/shared/service/clmtlk.service';
import * as i5 from '../../../../../../app/clmtlk/shared/service/clmtlk-session.service';
import * as i6 from 'ngx-toastr';
const styles_MessageEditorComponent:any[] = [i0.styles];
export const RenderType_MessageEditorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MessageEditorComponent,data:{}});
export function View_MessageEditorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'textarea',[['class',
      'form-control']],[[8,'id',0]],(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(_ck,_v) => {
        var _co:i2.MessageEditorComponent = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.elementId,'');
        _ck(_v,0,0,currVal_0);
      });
}
export function View_MessageEditorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'clmtlk-message-editor',
      ([] as any[]),(null as any),(null as any),(null as any),View_MessageEditorComponent_0,
      RenderType_MessageEditorComponent)),i1.ɵprd(5120,(null as any),i3.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.MessageEditorComponent]),i1.ɵdid(2,4440064,(null as any),0,i2.MessageEditorComponent,
      [i4.ClmtlkService,i5.ClmtlkSessionService,i6.ToastrService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(null as any));
}
export const MessageEditorComponentNgFactory:i1.ComponentFactory<i2.MessageEditorComponent> = i1.ɵccf('clmtlk-message-editor',
    i2.MessageEditorComponent,View_MessageEditorComponent_Host_0,{elementId:'elementId'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL25ldy1tZXNzYWdlL21lc3NhZ2UtZm9ybS9tZXNzYWdlLWVkaXRvci9tZXNzYWdlLWVkaXRvci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jbG10bGsvbmV3LW1lc3NhZ2UvbWVzc2FnZS1mb3JtL21lc3NhZ2UtZWRpdG9yL21lc3NhZ2UtZWRpdG9yLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL25ldy1tZXNzYWdlL21lc3NhZ2UtZm9ybS9tZXNzYWdlLWVkaXRvci9tZXNzYWdlLWVkaXRvci5jb21wb25lbnQudHMuTWVzc2FnZUVkaXRvckNvbXBvbmVudC5odG1sIiwibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jbG10bGsvbmV3LW1lc3NhZ2UvbWVzc2FnZS1mb3JtL21lc3NhZ2UtZWRpdG9yL21lc3NhZ2UtZWRpdG9yLmNvbXBvbmVudC50cy5NZXNzYWdlRWRpdG9yQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHRleHRhcmVhIGlkPVwie3tlbGVtZW50SWR9fVwiIGNsYXNzPVwiZm9ybS1jb250cm9sXCI+PC90ZXh0YXJlYT4iLCI8Y2xtdGxrLW1lc3NhZ2UtZWRpdG9yPjwvY2xtdGxrLW1lc3NhZ2UtZWRpdG9yPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTs7O1FBQVU7UUFBVixXQUFVLFNBQVY7Ozs7b0JDQUE7TUFBQTt1Q0FBQTtNQUFBO1FBQUE7TUFBQSxzQ0FBQTtNQUFBOztRQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/new-message/message-form/message-editor/message-editor.component.ngfactory.ts